import { useState } from 'react';

export interface UseMedicationsResult {
  showDoseSpotIFrame: boolean;
  setShowDoseSpotIFrame: (showDoseSpotIFrame: boolean) => void;
}

export function useMedications(): UseMedicationsResult {
  const [showDoseSpotIFrame, setShowDoseSpotIFrame] = useState(false);

  return {
    showDoseSpotIFrame,
    setShowDoseSpotIFrame,
  };
}
